// extracted by mini-css-extract-plugin
module.exports = {"bookClassContainer":"ShyftPassClassListPage_bookClassContainer__CeapA","faqs":"ShyftPassClassListPage_faqs__yXTxy","noClassFound":"ShyftPassClassListPage_noClassFound__LWYUj"};